import { z } from 'zod';

export interface SessionInfo {
  id: string;
  current: boolean;
  userAgent: string;
  ip: string;
  remember: boolean;
  createdAt: string;
  lastSeenAt: string;
}

export interface NotificationSettings {
  telegram: { enabled: boolean; chatId: string; hasToken: boolean };
  digest: { enabled: boolean; time: string };
}

export const notificationSettingsSchema = z.object({
  telegram: z
    .object({
      enabled: z.boolean().optional(),
      chatId: z.string().trim().max(40).optional(),
      /** Nuovo token del bot; null per toglierlo. */
      token: z.string().trim().max(200).nullable().optional(),
    })
    .optional(),
  digest: z
    .object({
      enabled: z.boolean().optional(),
      time: z
        .string()
        .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Orario non valido')
        .optional(),
    })
    .optional(),
});
export type NotificationSettingsInput = z.infer<typeof notificationSettingsSchema>;

export interface AuditEntry {
  id: string;
  action: string;
  entity: string | null;
  meta: unknown;
  ip: string | null;
  createdAt: string;
}

/** Descrizioni leggibili delle azioni del registro. */
export const AUDIT_LABELS: Record<string, string> = {
  'login.ok': 'Accesso',
  'login.failed': 'Accesso non riuscito',
  'login.unknown': 'Accesso con email sconosciuta',
  logout: 'Uscita',
  'auth.setup': 'Configurazione iniziale',
  'auth.reset': 'Recupero accesso',
  'auth.reauth': 'Conferma identità',
  'vault.create': 'Nuovo accesso salvato',
  'vault.reveal': 'Password mostrata',
  'vault.update': 'Accesso modificato',
  'vault.delete': 'Accesso eliminato',
  'page.create': 'Scheda creata',
  'page.archive': 'Scheda archiviata',
  'page.restore': 'Scheda ripristinata',
  'page.delete': 'Scheda eliminata',
  'media.delete': 'Contenuto eliminato',
  'settings.notifications': 'Impostazioni notifiche',
  'session.revoke': 'Dispositivo scollegato',
  'backup.download': 'Copia del database scaricata',
};
